// extracted by mini-css-extract-plugin
module.exports = {"slide":"BenefitSlider_slide__DjaVy"};